const state = () => ({
  loaded: true,
});

const mutations = {
  LOADED(state, bool) {
    state.loaded = bool;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
};
